import { Box, Button, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../state/state';
import { isLaterThanDay, isOnMonthlyBillPlan } from '../../state/helpers';
import { stringHelper } from '../../utils/stringHelper';
import { useState } from 'react';
import { ScheduledPaymentWarningModal } from './ScheduledPaymentWarningModal';

export const ScheduledPaymentBanner = () => {
  const [membershipDetails] = useGlobalState('memberDetails');
  const { currentBillPlan, loggedInMember } = membershipDetails;
  const loggedInRoleType = loggedInMember?.roleType;
  const [paymentInfo] = useGlobalState('paymentInfo');
  const { scheduledPaymentData } = paymentInfo;
  const [showScheduledPaymentWarningModal, setShowScheduledPaymentWarningModal] = useState(false);

  const getBannerMessage = () => {
    if (typeof scheduledPaymentData !== 'string') {
      const { paymentAmount, scheduledDate } = scheduledPaymentData;
      return (
        <Typography variant="b2Regular" sx={{ color: '#404040' }} className="scheduled-payment-message">
          One-time payment scheduled for <strong>{stringHelper.formatMoney(paymentAmount || '0')}</strong> on{' '}
          <strong>{scheduledDate}</strong>.
        </Typography>
      );
    }
  };

  const bannerMessage = getBannerMessage();

  const showCancelButton = () => {
    if (typeof scheduledPaymentData !== 'string') {
      const { scheduledDate } = scheduledPaymentData;
      return isLaterThanDay(scheduledDate);
    }
  };

  const isOnAnnual = !isOnMonthlyBillPlan(currentBillPlan!);
  const showScheduledPayment =
    (loggedInRoleType === RoleType.PRIMARY || loggedInRoleType === RoleType.ADULT_ASSOCIATE) &&
    isOnAnnual &&
    typeof scheduledPaymentData !== 'string';

  return (
    <Box>
      {showScheduledPayment && (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ backgroundColor: '#EFF7FE', height: '4rem', width: '100%', padding: '0.5rem 1rem' }}
          className="scheduled-payment-container"
          gap="1rem"
        >
          {bannerMessage}
          {showCancelButton() && (
            <Button
              label={
                <Typography sx={{ color: '#1C4DA6' }} variant="b2Regular">
                  Cancel
                </Typography>
              }
              variant="outlined"
              className="cancel-scheduled-payment-button"
              sx={{ padding: '0.5rem 0.625rem', width: '4rem', height: '2.5rem', borderRadius: '0.75rem' }}
              onClick={() => setShowScheduledPaymentWarningModal(true)}
            />
          )}
        </Stack>
      )}
      <ScheduledPaymentWarningModal
        visible={showScheduledPaymentWarningModal}
        onClose={() => {
          setShowScheduledPaymentWarningModal(false);
        }}
      />
    </Box>
  );
};
